module.exports = __webpack_public_path__ + "img/coin-ETH.3f47bdb0.svg";